import { computed } from 'vue'
import { useBreakpoints } from '@vueuse/core'

/**
 * 响应式列数 Hook
 * 根据屏幕尺寸自动计算瀑布流列数
 * @returns 当前屏幕对应的列数
 */
export function useResponsiveColumns() {
  // 定义屏幕断点
  const breakpoints = useBreakpoints({
    mobile: 640, // 手机端
    tablet: 1024, // 平板
    laptop: 1280, // 笔记本
    desktop: 1536, // 桌面
  })

  // 根据屏幕尺寸动态计算列数
  const columns = computed(() => {
    if (breakpoints.isGreater('desktop')) {
      return 7 // 桌面及以上：7列
    } else if (breakpoints.isGreater('laptop')) {
      return 6 // 笔记本：6列
    } else if (breakpoints.isGreater('tablet')) {
      return 4 // 平板：4列
    } else {
      return 2 // 手机：2列
    }
  })

  return {
    columns,
    breakpoints,
  }
}
